module.exports = __webpack_public_path__ + "img/news8-3.8f73f049.png";